export default __webpack_public_path__ + "static/media/magician.8b9cca8b.png";